var _line, _g, _g2, _line2, _g3, _line3, _g4, _g5, _line4, _line5, _g6, _line6, _line7, _g7, _line8, _text, _text2, _text3, _g8, _g9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewDkHelpWall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "550.5px",
    height: "610px",
    viewBox: "0 0 550.5 610",
    enableBackground: "new 0 0 550.5 610",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9679,
    x1: 2,
    y1: 600.3,
    x2: 462,
    y2: 600.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M484.1,606.6v-13.3h8.7v1.5h-7.1v4.3h6.9v1.5h-6.9v6.1H484.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M494.9,606.6v-13.3h1.7v11.9h6.2v1.5H494.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M505.3,603.5c-0.5-1-0.8-2.2-0.8-3.5s0.3-2.5,0.8-3.5c0.5-1,1.3-1.9,2.3-2.5s2.2-0.9,3.5-0.9 c1.3,0,2.4,0.3,3.5,0.9c1,0.6,1.8,1.4,2.4,2.5s0.8,2.2,0.8,3.5s-0.3,2.5-0.8,3.5s-1.3,1.9-2.4,2.5c-1,0.6-2.2,0.9-3.5,0.9 c-1.3,0-2.4-0.3-3.5-0.9S505.8,604.5,505.3,603.5z M506.2,599.9c0,1,0.2,2,0.6,2.8c0.4,0.8,1,1.5,1.7,1.9s1.6,0.7,2.6,0.7 s1.8-0.2,2.6-0.7s1.3-1.1,1.7-1.9s0.6-1.7,0.6-2.8c0-1.6-0.5-2.9-1.4-3.9c-0.9-1-2.1-1.5-3.6-1.5c-1.5,0-2.7,0.5-3.6,1.5 S506.2,598.4,506.2,599.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M520.6,603.5c-0.5-1-0.8-2.2-0.8-3.5s0.3-2.5,0.8-3.5c0.5-1,1.3-1.9,2.3-2.5s2.2-0.9,3.5-0.9 c1.3,0,2.4,0.3,3.5,0.9c1,0.6,1.8,1.4,2.4,2.5s0.8,2.2,0.8,3.5s-0.3,2.5-0.8,3.5s-1.3,1.9-2.4,2.5c-1,0.6-2.2,0.9-3.5,0.9 c-1.3,0-2.4-0.3-3.5-0.9S521.1,604.5,520.6,603.5z M521.4,599.9c0,1,0.2,2,0.6,2.8c0.4,0.8,1,1.5,1.7,1.9s1.6,0.7,2.6,0.7 s1.8-0.2,2.6-0.7s1.3-1.1,1.7-1.9s0.6-1.7,0.6-2.8c0-1.6-0.5-2.9-1.4-3.9c-0.9-1-2.1-1.5-3.6-1.5c-1.5,0-2.7,0.5-3.6,1.5 S521.4,598.4,521.4,599.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M535.6,606.6v-13.3h5.4c1.2,0,2.2,0.4,3,1.1s1.2,1.7,1.2,2.9c0,0.6-0.1,1.1-0.3,1.6 c-0.2,0.5-0.5,0.9-0.8,1.2c-0.3,0.3-0.7,0.6-1.1,0.8c-0.4,0.2-0.9,0.3-1.3,0.3l3.6,5.4h-2l-3.4-5.3h-2.7v5.3H535.6z M537.2,599.8 h3.5c0.8,0,1.4-0.2,1.9-0.7c0.5-0.5,0.8-1.1,0.8-1.8s-0.2-1.4-0.7-1.8s-1.1-0.7-1.9-0.7h-3.5V599.8z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 91.9,
    y: 123.1,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 146.2,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9679,
    x1: 2,
    y1: 13.1,
    x2: 462,
    y2: 13.1
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M475.3,15.6c-0.4-0.9-0.5-1.8-0.5-2.8s0.2-1.9,0.5-2.8s0.8-1.6,1.5-2.2s1.3-1.1,2.2-1.4 c0.8-0.3,1.7-0.5,2.7-0.5c2.1,0,3.8,0.9,5.1,2.6l-1.4,0.8c-0.4-0.6-0.9-1.1-1.6-1.4c-0.7-0.4-1.4-0.5-2.1-0.5 c-1.5,0-2.7,0.5-3.7,1.5s-1.5,2.3-1.5,3.9c0,1,0.2,2,0.7,2.8s1.1,1.5,1.8,1.9s1.7,0.7,2.6,0.7c0.7,0,1.4-0.2,2.1-0.5 c0.7-0.4,1.2-0.8,1.6-1.4l1.4,0.8c-1.3,1.8-3,2.7-5.1,2.7c-1,0-1.8-0.2-2.7-0.5c-0.8-0.3-1.6-0.8-2.2-1.4S475.7,16.5,475.3,15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M488.8,19.4V6.1h8.7v1.5h-7.1v4.3h6.9v1.5h-6.9V18h7.1v1.5H488.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M500.2,19.4V6.1h1.7v13.3H500.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M504.8,19.4V6.1h1.7V18h6.2v1.5H504.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M514.8,19.4V6.1h1.7v13.3H514.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M519.6,19.4V6.1h1.7l7.7,10.4V6.1h1.7v13.3H529l-7.8-10.6v10.6H519.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M533.8,15.6c-0.4-0.9-0.5-1.8-0.5-2.8s0.2-2,0.5-2.8c0.4-0.9,0.8-1.6,1.5-2.2c0.6-0.6,1.3-1.1,2.2-1.4 c0.8-0.3,1.7-0.5,2.7-0.5c2.1,0,3.9,0.8,5.2,2.5l-1.3,0.8c-0.4-0.6-1-1-1.7-1.3s-1.4-0.5-2.2-0.5c-1.5,0-2.7,0.5-3.7,1.5 s-1.5,2.3-1.5,3.9c0,1,0.2,2,0.7,2.8c0.4,0.8,1.1,1.5,1.8,1.9c0.8,0.5,1.7,0.7,2.6,0.7c0.7,0,1.4-0.1,2.1-0.4 c0.6-0.3,1.2-0.6,1.5-1v-2.7h-4.6v-1.5h6.2v4.8c-0.6,0.7-1.4,1.3-2.3,1.7c-0.9,0.4-1.9,0.6-2.9,0.6c-0.9,0-1.8-0.2-2.7-0.5 c-0.8-0.3-1.6-0.8-2.2-1.4C534.6,17.2,534.1,16.5,533.8,15.6z"
  }))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.5888,
    x1: 57,
    y1: 78.1,
    x2: 407,
    y2: 78.1
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M412.9,84.4V71.1h4.6c1.4,0,2.6,0.3,3.6,0.9c1,0.6,1.8,1.4,2.4,2.4c0.6,1,0.8,2.1,0.8,3.4 c0,0.9-0.2,1.8-0.5,2.6c-0.3,0.8-0.8,1.5-1.4,2.1s-1.3,1.1-2.2,1.4c-0.9,0.3-1.8,0.5-2.8,0.5H412.9z M414.6,83h2.9 c1,0,2-0.2,2.8-0.7c0.8-0.5,1.4-1.1,1.8-1.9c0.4-0.8,0.6-1.6,0.6-2.6c0-1-0.2-1.9-0.6-2.6c-0.4-0.8-1-1.4-1.8-1.9 c-0.8-0.5-1.7-0.7-2.8-0.7h-2.9V83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M426.9,84.4V71.1h1.7V78l5.9-6.9h2.1l-5.6,6.3l6.1,7H435l-5.1-6l-1.3,1.5v4.5H426.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M444.1,84.4V71.1h1.7v5.7h7.8v-5.7h1.7v13.3h-1.7v-6.1h-7.8v6.1H444.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M456.9,84.4l5.4-13.3h2.1l5.4,13.3h-1.9l-1.2-3H460l-1.2,3H456.9z M460.5,80h5.7l-2.8-7.2L460.5,80z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M471.5,84.4V71.1h5.4c1.2,0,2.2,0.4,3,1.1s1.2,1.7,1.2,2.9c0,0.6-0.1,1.1-0.3,1.6c-0.2,0.5-0.5,0.9-0.8,1.2 c-0.3,0.3-0.7,0.6-1.1,0.8c-0.4,0.2-0.9,0.3-1.3,0.3l3.6,5.4h-2l-3.4-5.3h-2.7v5.3H471.5z M473.1,77.7h3.5c0.8,0,1.4-0.2,1.9-0.7 c0.5-0.5,0.8-1.1,0.8-1.8s-0.2-1.4-0.7-1.8s-1.1-0.7-1.9-0.7h-3.5V77.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M483.7,84.4V71.1h4.6c1.4,0,2.6,0.3,3.6,0.9c1,0.6,1.8,1.4,2.4,2.4c0.6,1,0.8,2.1,0.8,3.4 c0,0.9-0.2,1.8-0.5,2.6c-0.3,0.8-0.8,1.5-1.4,2.1s-1.3,1.1-2.2,1.4c-0.9,0.3-1.8,0.5-2.8,0.5H483.7z M485.3,83h2.9 c1,0,2-0.2,2.8-0.7c0.8-0.5,1.4-1.1,1.8-1.9c0.4-0.8,0.6-1.6,0.6-2.6c0-1-0.2-1.9-0.6-2.6c-0.4-0.8-1-1.4-1.8-1.9 c-0.8-0.5-1.7-0.7-2.8-0.7h-2.9V83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M496.4,71.1h1.9l2.9,11.1l3.1-11.1h1.4l3.1,11.1l3-11.1h1.9l-3.8,13.3h-1.8l-2.9-10.7L502,84.4h-1.8 L496.4,71.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M513.9,84.4l5.4-13.3h2.1l5.4,13.3h-1.9l-1.2-3H517l-1.2,3H513.9z M517.5,80h5.7l-2.8-7.2L517.5,80z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M528.5,84.4V71.1h5.4c1.2,0,2.2,0.4,3,1.1s1.2,1.7,1.2,2.9c0,0.6-0.1,1.1-0.3,1.6c-0.2,0.5-0.5,0.9-0.8,1.2 c-0.3,0.3-0.7,0.6-1.1,0.8c-0.4,0.2-0.9,0.3-1.3,0.3l3.6,5.4h-2l-3.4-5.3h-2.7v5.3H528.5z M530.1,77.7h3.5c0.8,0,1.4-0.2,1.9-0.7 c0.5-0.5,0.8-1.1,0.8-1.8s-0.2-1.4-0.7-1.8s-1.1-0.7-1.9-0.7h-3.5V77.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M540.6,84.4V71.1h8.7v1.5h-7.1v4.3h6.9v1.5h-6.9V83h7.1v1.5H540.6z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 358.1,
    y1: 537.5,
    x2: 105.9,
    y2: 537.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "355.4,528.5 371,537.5 355.4,546.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "108.6,528.5 93,537.5 108.6,546.5  "
  }))))), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.6287,
    x1: 372.1,
    y1: 520,
    x2: 372.1,
    y2: 555
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.6287,
    x1: 91.9,
    y1: 520,
    x2: 91.9,
    y2: 555
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 66,
    y1: 137.5,
    x2: 66,
    y2: 497.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "57,140.1 66,124.6 75,140.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "57,495.1 66,510.6 75,495.1  "
  }))))), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.6287,
    x1: 48.5,
    y1: 123.1,
    x2: 83.5,
    y2: 123.1
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.6287,
    x1: 48.5,
    y1: 512.1,
    x2: 83.5,
    y2: 512.1
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9481,
    x1: 25.7,
    y1: 137.3,
    x2: 25.7,
    y2: 590.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "16.8,139.9 25.6,124.6 34.5,139.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "16.8,588.3 25.6,603.6 34.5,588.3  "
  }))))), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.6287,
    x1: 8.2,
    y1: 123.1,
    x2: 43.2,
    y2: 123.1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 8.4827 323.3137)",
    fill: "#464545",
    fontFamily: "'ProximaNova-Regular'",
    fontSize: 18
  }, "A")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 49.6732 323.3137)",
    fill: "#464545",
    fontFamily: "'ProximaNova-Regular'",
    fontSize: 18
  }, "B")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 225.918 554.9758)",
    fill: "#464545",
    fontFamily: "'ProximaNova-Regular'",
    fontSize: 18
  }, "C")), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.9825,
    x1: 232,
    y1: 87.8,
    x2: 232,
    y2: 112.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "226.1,89.6 232,79.3 237.9,89.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "226.1,111 232,121.2 237.9,111  "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M246.8,97.1l3-3.1h1.3v12h-1.5v-10l-1.9,2.1L246.8,97.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M253.7,104.3l0.9-1c0.8,1.1,1.9,1.6,3.3,1.6c0.8,0,1.5-0.2,2-0.7s0.8-1.1,0.8-1.8c0-0.8-0.3-1.4-0.8-1.9 s-1.2-0.7-2-0.7c-1.1,0-2,0.4-2.8,1.1l-1.1-0.4V94h7.3v1.3h-5.9v4.2c0.3-0.3,0.7-0.6,1.2-0.8s1-0.3,1.6-0.3c0.5,0,1,0.1,1.4,0.3 s0.9,0.4,1.2,0.7s0.6,0.7,0.8,1.2s0.3,1.1,0.3,1.7c0,1.2-0.4,2.1-1.2,2.9c-0.8,0.7-1.8,1.1-3.1,1.1 C256.1,106.2,254.7,105.6,253.7,104.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M263.7,102.2V101h4.3v1.2H263.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M269.5,95.7c0.5-0.6,1-1.1,1.8-1.4c0.7-0.3,1.5-0.5,2.4-0.5c0.5,0,1,0.1,1.5,0.2c0.5,0.1,0.9,0.4,1.3,0.6 c0.4,0.3,0.7,0.7,0.9,1.1s0.3,1,0.3,1.6c0,0.5-0.1,1-0.3,1.5s-0.5,1-0.8,1.4c-0.3,0.4-0.7,0.9-1.3,1.5c-0.5,0.5-1.1,1-1.6,1.4 s-1.2,1-1.9,1.5h5.9v1.3h-8.2v-1.2c0.8-0.6,1.5-1.2,2-1.6c0.5-0.4,1.1-0.9,1.6-1.4c0.6-0.5,1-0.9,1.3-1.3c0.3-0.4,0.6-0.7,0.9-1.1 c0.3-0.4,0.5-0.7,0.6-1.1c0.1-0.3,0.2-0.7,0.2-1c0-0.7-0.2-1.3-0.7-1.6s-1.1-0.6-1.8-0.6c-0.7,0-1.3,0.1-1.9,0.4 c-0.6,0.3-1,0.6-1.4,1.1L269.5,95.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M280.1,100c0-0.6,0.1-1.2,0.2-1.8c0.1-0.6,0.3-1.1,0.5-1.7c0.2-0.5,0.5-1,0.9-1.4c0.3-0.4,0.8-0.7,1.3-1 c0.5-0.2,1.1-0.4,1.7-0.4c0.6,0,1.2,0.1,1.7,0.4c0.5,0.2,1,0.6,1.3,1c0.3,0.4,0.6,0.9,0.9,1.4c0.2,0.5,0.4,1.1,0.5,1.7 c0.1,0.6,0.2,1.2,0.2,1.8c0,0.6-0.1,1.2-0.2,1.8c-0.1,0.6-0.3,1.1-0.5,1.7c-0.2,0.5-0.5,1-0.9,1.4s-0.8,0.7-1.3,1 c-0.5,0.2-1.1,0.4-1.7,0.4c-0.6,0-1.2-0.1-1.7-0.4c-0.5-0.2-1-0.6-1.3-1s-0.6-0.9-0.9-1.4c-0.2-0.5-0.4-1.1-0.5-1.7 C280.1,101.2,280.1,100.6,280.1,100z M281.6,100c0,0.6,0.1,1.2,0.2,1.8c0.1,0.6,0.3,1.1,0.5,1.5c0.2,0.5,0.5,0.9,1,1.1 c0.4,0.3,0.9,0.4,1.4,0.4s1-0.1,1.4-0.4c0.4-0.3,0.7-0.7,1-1.1c0.2-0.5,0.4-1,0.5-1.5c0.1-0.6,0.2-1.1,0.2-1.8c0-0.5,0-1-0.1-1.4 c-0.1-0.5-0.2-0.9-0.3-1.3c-0.2-0.4-0.3-0.8-0.6-1.1c-0.2-0.3-0.5-0.6-0.9-0.7c-0.4-0.2-0.8-0.3-1.2-0.3c-0.4,0-0.8,0.1-1.2,0.3 c-0.4,0.2-0.6,0.4-0.9,0.7c-0.2,0.3-0.4,0.7-0.6,1.1c-0.2,0.4-0.3,0.9-0.3,1.3C281.6,99,281.6,99.5,281.6,100z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M291,101.6c0-0.9,0.2-1.6,0.5-2.3c0.4-0.7,0.9-1.2,1.5-1.6c0.7-0.4,1.4-0.6,2.3-0.6c1.3,0,2.4,0.5,3.2,1.5 l-0.9,0.8c-0.5-0.7-1.3-1.1-2.2-1.1c-0.9,0-1.6,0.3-2.2,0.9s-0.8,1.4-0.8,2.4c0,1,0.3,1.8,0.8,2.4s1.3,1,2.2,1 c0.9,0,1.6-0.4,2.2-1.1l0.9,0.8c-0.8,1-1.8,1.5-3.2,1.5c-1.3,0-2.3-0.4-3.1-1.3C291.4,104,291,102.9,291,101.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M300.4,106v-8.7h1.3v1.3c0.2-0.3,0.6-0.7,1.2-1s1.1-0.5,1.7-0.5c0.6,0,1.1,0.2,1.5,0.5s0.7,0.7,0.8,1.2 c0.3-0.4,0.7-0.8,1.2-1.1s1.1-0.5,1.7-0.5c0.8,0,1.4,0.2,1.8,0.7s0.6,1.1,0.6,2v6.3h-1.3v-5.9c0-1.2-0.5-1.8-1.6-1.8 c-0.4,0-0.9,0.1-1.3,0.4s-0.8,0.6-1,0.9v6.4h-1.3v-5.9c0-1.2-0.5-1.8-1.6-1.8c-0.4,0-0.8,0.1-1.3,0.4c-0.4,0.3-0.8,0.6-1,1v6.4 H300.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDkHelpWall);
export default __webpack_public_path__ + "static/media/new_dk_Help_wall.3d4c31a3ef74150f393aa39fd6ccf864.svg";
export { ForwardRef as ReactComponent };